@if (showTimeline()) {
	<skl-creator-timeline
		[steps]="timelineSteps"
		[currentStep]="currentStep"
		(onStepChange)="timelineChange($event)">
	</skl-creator-timeline>
}
<div class="js-creator-steps-container relative-height"></div>